import React, { useState } from "react";
import { procCur } from "./procHelpers";
import {
  PROC_GROUPS, PROC_LEVELS, procLevelIn, procMe, procMembers, procName, procPeople, procWhoName,
} from "./procPeople";
import { Icon, PrIco, ProcAv } from "./ProcUi";

// Droits d'accès d'un espace ou d'une page — repris du prototype
// (procedures-acl.jsx). La logique de droits elle-même est dans procPeople.js.

const ProcAclAv = ({ who, size = 28 }) =>
  who.startsWith("g:")
    ? <span className="pr-acl-g" style={{ width: size, height: size }}><PrIco n="people" s={size * 0.55} /></span>
    : <ProcAv id={who.replace(/^u:/, "")} size={size} />;

const ProcAccessModal = ({ db, target, onSave, onClose }) => {
  const isPage = target.kind === "page";
  const page = isPage ? db.pages.find((p) => p.id === target.id) : null;
  const space = db.spaces.find((s) => s.id === (isPage ? page.spaceId : target.id));
  const [inherit, setInherit] = useState(isPage ? !page.acl : false);
  const [acl, setAcl] = useState(() => JSON.parse(JSON.stringify((isPage && page.acl) || space.acl || [])));
  const [add, setAdd] = useState("");
  const [addLvl, setAddLvl] = useState("read");
  const [showWho, setShowWho] = useState(false);
  const eff = inherit ? space.acl : acl;
  const me = procMe();
  const C = procPeople();
  const byLvl = (r) => C.filter((c) => procLevelIn(eff, c.id) === r);
  const readers = byLvl(1);
  const editors = byLvl(2);
  const managers = byLvl(3);
  const none = byLvl(0);
  const selfLocked = procLevelIn(eff, me) < 3;
  const used = new Set(acl.map((e) => e.who));
  const setLvl = (who, level) => setAcl((a) => a.map((e) => (e.who === who ? { ...e, level } : e)));
  const doAdd = () => {
    if (!add) return;
    setAcl((a) => [...a, { who: add, level: addLvl }]);
    setAdd("");
  };
  const startCustom = () => {
    setAcl(JSON.parse(JSON.stringify(space.acl || [])));
    setInherit(false);
  };

  return (
    <div className="scrim" onClick={onClose}>
      <div className="modal pr-acl-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <div className="icon-square"><PrIco n="lock" s={20} /></div>
          <div>
            <h2>{isPage ? "Accès à la procédure" : "Accès à l'espace"}</h2>
            <div className="meta"><span style={{ fontSize: 12.5, color: "var(--ink-3)" }}>{isPage ? procCur(page).title : space.name}</span></div>
          </div>
          <div className="actions"><button className="x-btn" onClick={onClose}><Icon name="x" size={16} /></button></div>
        </div>
        <div className="modal-body pr-acl-body">
          {isPage && (
            <div className="pr-acl-mode">
              <button className={inherit ? "on" : ""} onClick={() => setInherit(true)}>
                <b>Accès de l'espace</b><small>Mêmes droits que « {space.name} »</small>
              </button>
              <button className={!inherit ? "on" : ""} onClick={() => { if (inherit) startCustom(); }}>
                <b>Accès spécifiques</b><small>Droits propres à cette page</small>
              </button>
            </div>
          )}
          <div className={`pr-acl-list ${inherit ? "is-ro" : ""}`}>
            {eff.map((e) => (
              <div key={e.who} className="pr-acl-row">
                <ProcAclAv who={e.who} />
                <span className="pr-acl-name">
                  <b>{procWhoName(e.who)}</b>
                  {e.who.startsWith("g:") && <small>{procMembers(e.who).length} personne{procMembers(e.who).length > 1 ? "s" : ""}</small>}
                </span>
                {inherit ? (
                  <span className="pr-acl-lvl-ro">{PROC_LEVELS[e.level].lab}</span>
                ) : (
                  <>
                    <select className="pr-f-in pr-acl-sel" value={e.level} onChange={(ev) => setLvl(e.who, ev.target.value)}>
                      {Object.entries(PROC_LEVELS).map(([k, l]) => <option key={k} value={k}>{l.lab}</option>)}
                    </select>
                    <button className="pr-acl-rm" title="Retirer" onClick={() => setAcl((a) => a.filter((x) => x.who !== e.who))}>
                      <Icon name="x" size={14} />
                    </button>
                  </>
                )}
              </div>
            ))}
            {!eff.length && <div className="pr-empty">Aucun accès défini.</div>}
          </div>
          {!inherit && (
            <div className="pr-acl-add">
              <select className="pr-f-in" value={add} onChange={(e) => setAdd(e.target.value)}>
                <option value="">Ajouter une personne ou un groupe…</option>
                <optgroup label="Groupes">
                  {PROC_GROUPS.filter((g) => !used.has(g.id)).map((g) => <option key={g.id} value={g.id}>{g.name}</option>)}
                </optgroup>
                <optgroup label="Collaborateurs">
                  {C.filter((c) => !used.has("u:" + c.id)).map((c) => <option key={c.id} value={"u:" + c.id}>{c.name}</option>)}
                </optgroup>
              </select>
              <select className="pr-f-in pr-acl-sel" value={addLvl} onChange={(e) => setAddLvl(e.target.value)}>
                {Object.entries(PROC_LEVELS).map(([k, l]) => <option key={k} value={k}>{l.lab}</option>)}
              </select>
              <button className="btn" disabled={!add} onClick={doAdd}>Ajouter</button>
            </div>
          )}
          <div className="pr-acl-sum">
            <span><b>{readers.length + editors.length + managers.length}</b> peuvent lire</span>
            <span><b>{editors.length + managers.length}</b> peuvent modifier</span>
            <span><b>{none.length}</b> sans accès</span>
            <button className="pr-link" onClick={() => setShowWho(!showWho)}>{showWho ? "Masquer" : "Voir qui"}</button>
          </div>
          {showWho && (
            <div className="pr-acl-who">
              {[["Gestion", managers], ["Modification", editors], ["Lecture", readers], ["Sans accès", none]]
                .filter(([, l]) => l.length)
                .map(([lab, l]) => (
                  <div key={lab}>
                    <div className="pr-acl-who-h">{lab}</div>
                    <div className="pr-acl-who-l">
                      {l.map((c) => <span key={c.id}><ProcAv id={c.id} size={18} /> {procName(c.id)}</span>)}
                    </div>
                  </div>
                ))}
            </div>
          )}
          {selfLocked && !inherit && (
            <div className="pr-banner warn">
              <Icon name="alert" size={14} /> Avec ces réglages, vous ne pourrez plus gérer les accès de {isPage ? "cette page" : "cet espace"}.
            </div>
          )}
        </div>
        <div className="pr-new-foot">
          <button className="btn" onClick={onClose}>Annuler</button>
          <button className="btn primary" disabled={!inherit && !acl.length} onClick={() => onSave(isPage && inherit ? null : acl)}>Enregistrer</button>
        </div>
      </div>
    </div>
  );
};

export default ProcAccessModal;
